import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { IncidentSeverity, IncidentSeverityLabelKeys } from '../../../../../enums/incident-severity.enum';
import { DetectedAccident } from '../../../../../models/accidents-and-incidents-response.model';
import { InsuranceClaimData } from '../../claim-insurance.model';

@Component({
  selector: 'app-insurance-claim-tab',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbDropdownModule, TranslocoDirective, TranslocoPipe],
  templateUrl: './insurance-claim-tab.component.html',
  styleUrl: './insurance-claim-tab.component.scss'
})
export class InsuranceClaimTabComponent implements OnInit {
  private fb: FormBuilder = inject(FormBuilder);
  private readonly transloco: TranslocoService = inject(TranslocoService);

  @Input() accident: DetectedAccident | null = null;
  @Input() isSubmitting: boolean = false;
  @Input() areDocumentsReady: boolean = true;
  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<InsuranceClaimData>();

  claimForm: FormGroup;

  severities: IncidentSeverity[] = [
    IncidentSeverity.LowImpact,
    IncidentSeverity.MediumImpact,
    IncidentSeverity.HighImpact
  ];
  severityLabelKeys = IncidentSeverityLabelKeys;

  selectedSeverity: IncidentSeverity | null = null;

  constructor() {
    this.claimForm = this.fb.group({
      insuranceCompany: ['', Validators.required],
      policyNumber: ['', Validators.required],
      incidentDescription: ['']
    });
  }

  ngOnInit(): void {}

  get severityLabel(): string {
    return this.transloco.translate(
      this.selectedSeverity ? this.severityLabelKeys[this.selectedSeverity] : 'accidents.modals.insuranceClaim.selectSeverity'
    );
  }

  onSeveritySelect(severity: IncidentSeverity): void {
    this.selectedSeverity = severity;
  }

  get isFormValid(): boolean {
    return !!(
      this.claimForm.get('insuranceCompany')?.value?.trim() &&
      this.claimForm.get('policyNumber')?.value?.trim() &&
      this.selectedSeverity
    );
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSave(): void {
    if (!this.isFormValid || this.isSubmitting || !this.areDocumentsReady) {
      return;
    }

    const result: InsuranceClaimData = {
      insuranceCompany: this.claimForm.get('insuranceCompany')?.value.trim(),
      policyNumber: this.claimForm.get('policyNumber')?.value.trim(),
      severity: this.selectedSeverity,
      incidentDescription: this.claimForm.get('incidentDescription')?.value
    };
    this.save.emit(result);
  }
}